module.exports = __webpack_public_path__ + "img/imagen1.349cb75d.png";